export const LOCATION_GROUPING_MODEL = "location-grouping";

const locationGroupingModel = {
  name: "",
  category: ""
};

export default locationGroupingModel;
